type FunctionsClient = {
  functions: {
    invoke: (name: string, options?: { body?: unknown }) => Promise<{ data: unknown; error: unknown }>;
  };
};

function asRecord(value: unknown): Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : {};
}

function readString(record: Record<string, unknown>, key: string): string | null {
  return typeof record[key] === 'string' ? record[key] : null;
}

export interface PaymentCheckoutResponse {
  transaction_id?: string | null;
  payment_url?: string | null;
  redirect_url?: string | null;
  payment_form?: unknown;
  provider?: string | null;
  provider_mode?: string | null;
  environment?: string | null;
  status?: string | null;
  user_message?: string | null;
  error?: string | null;
}

export function getCheckoutRedirectUrl(data: PaymentCheckoutResponse | null | undefined) {
  return data?.payment_url || data?.redirect_url || null;
}

export function isMockCheckout(data: PaymentCheckoutResponse | null | undefined) {
  return data?.provider === 'mock' || data?.provider_mode === 'mock' || data?.environment === 'mock';
}

export function canActivateMockPaidCheckout(data: PaymentCheckoutResponse | null | undefined) {
  return Boolean(isMockCheckout(data) && data?.status === 'paid' && data?.transaction_id);
}

export async function activateMockPaidCheckout(client: FunctionsClient, data: PaymentCheckoutResponse) {
  if (!canActivateMockPaidCheckout(data)) {
    throw new Error(data.user_message || data.error || 'payment_checkout_unavailable');
  }

  const { data: verifyResult, error } = await client.functions.invoke('verify-payment', {
    body: { transaction_id: data.transaction_id },
  });

  if (error) throw error;
  const result = asRecord(verifyResult);
  if (result.status !== 'paid') {
    throw new Error(readString(result, 'user_message') || readString(result, 'error') || 'payment_confirmation_pending');
  }
  if (result.activated !== true) {
    throw new Error(
      readString(result, 'user_message') ||
        readString(result, 'error') ||
        'Payment activation failed. The wallet was not updated.',
    );
  }

  return result;
}
